import { useCallback, useEffect, useState } from 'react'
import { getHackWhatWorksWithCommentCounts, type HackWhatWork } from '@domain/features/pd-hacks/pd-hacks-feature'

export function useHackWhatWorks(symptomId: string | undefined) {
  const [whatWorks, setWhatWorks] = useState<HackWhatWork[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const load = useCallback(async () => {
    if (!symptomId) {
      setWhatWorks([])
      setError('Hack id is missing.')
      setLoading(false)
      return
    }

    try {
      setLoading(true)
      setError(null)
      const result = await getHackWhatWorksWithCommentCounts(symptomId)
      setWhatWorks(result)
    } catch (loadError) {
      setError(
        loadError instanceof Error
          ? loadError.message
          : 'Failed to load what works entries.',
      )
    } finally {
      setLoading(false)
    }
  }, [symptomId])

  useEffect(() => {
    void load()
  }, [load])

  return { whatWorks, loading, error, reload: load }
}
